import { render, staticRenderFns } from "./TheBurgerButton.vue?vue&type=template&id=5ef2c453&scoped=true&"
import script from "./TheBurgerButton.vue?vue&type=script&lang=js&"
export * from "./TheBurgerButton.vue?vue&type=script&lang=js&"
import style0 from "./TheBurgerButton.scss?vue&type=style&index=0&id=5ef2c453&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2c453",
  null
  
)

export default component.exports